<template>
  <div>
    <Header></Header>
    <div class="index-body">
      <!-- banner -->
      <div class="banner">
        <div class="title wrapper-box">
          <img src="../../../static/img/web_img/banner_title.png" />
        </div>
        <div class="btns">
          <router-link to="/AboutUs">About &nbsp; us</router-link>
          <router-link to="/Contact">Contact &nbsp; us</router-link>
        </div>
      </div>

      <!-- 供应链 -->
      <div class="intro-box wrapper-box">
        <img src="../../../static/img/web_img/img_gyl.png"/>
      </div>

      <!-- 业务 -->
      <div class="business">
        <div class="title"></div>
        <div class="list wrapper-box">
          <div class="item">
            <img class="img" src="../../../static/img/web_img/img_yewu1.png" />
            <i class="icon-yw1"></i>
            <h2>移库换标</h2>
            <p>无论数量多少，品种多少，蜂巢都将为用户提供专业系统化管理的退货清点、贴标发货服务。</p>
            <a>了解更多</a>
          </div>
          <div class="item">
            <img class="img" src="../../../static/img/web_img/img_yewu2.png" />
            <i class="icon-yw2"></i>
            <h2>尾货清仓</h2>
            <p>为用户提供最有价值的清仓方案，对接线下百家店铺，均位于美国东部人口最密集的区域。我们的优势在于不做中间商，直接对接商铺，体现您产品的真实价格，挽回损失。</p>
            <a>了解更多</a>
          </div>
          <div class="item">
            <img class="img" src="../../../static/img/web_img/img_yewu3.png" />
            <i class="icon-yw3"></i>
            <h2>一件代发</h2>
            <p>为用户提供专业的仓储物流服务。</p>
            <a>了解更多</a>
          </div>
        </div>
      </div>


      <!-- 联系我们 -->
      <div class="contact wrapper-box">
        <div class="title">
          <img src="../../../static/img/web_img/title_contact.png"/>
        </div>
        <div class="map">
          <img src="../../../static/img/web_img/map.png"/>
        </div>
      </div>
    </div>

    <Footer></Footer>
  </div>

</template>

<script>
  import Header from "@/components/header";
  import Footer from "@/components/footer";
  export default {
    components: {
      Header,
      Footer
    },
    data() {
      return {}
    }
  }
</script>

<style lang="scss" scoped src="../../../static/css/enter/main.scss"></style>
<style lang="scss" scoped src="../../../static/css/enter/media.scss"></style>


// WEBPACK FOOTER //
// src/pages/web/index.vue